import { createRef, useState } from "react";
// Components
import Option from "./Option";
import Transition from "./Transition";
import Button from "./Button";
// Styled
import styled from "styled-components";

const options = ["paper", "scissors", "rock"];

const PlayGround = ({ updateScore, score }) => {
  const [play, setPlay] = useState(false);
  const [option, setOption] = useState(null);
  const [houseOption, setHouseOption] = useState(null);
  const [result, setResult] = useState(null);
  const optionsRef = createRef();
  const gameRef = createRef();
  const resultRef = createRef();

  const getRandomValue = (values) => {
    return values[(Math.random() * values.length) | 0];
  };

  const getHouseOption = () => {
    return new Promise((res, rej) => {
      let houseOptionValue;
      const houseOptionsInterval = setInterval(() => {
        houseOptionValue = getRandomValue(options);
        setHouseOption(houseOptionValue);
      }, 100);
      setTimeout(() => {
        clearInterval(houseOptionsInterval);
        res(houseOptionValue);
      }, 2500);
    });
  };

  const getResult = (playerOption, houseOptionValue) => {
    if (playerOption === houseOptionValue) {
      return "DRAW";
    }
    if (playerOption === "paper") {
      if (houseOptionValue === "rock") {
        return "WIN";
      } else if (houseOptionValue === "scissors") {
        return "LOSE";
      }
    }
    if (playerOption === "scissors") {
      if (houseOptionValue === "rock") {
        return "LOSE";
      } else if (houseOptionValue === "paper") {
        return "WIN";
      }
    }
    if (playerOption === "rock") {
      if (houseOptionValue === "scissors") {
        return "WIN";
      } else if (houseOptionValue === "paper") {
        return "LOSE";
      }
    }
  };

  const handleTookOption = async (type) => {
    setPlay(true);
    setOption(type);
    const houseOptionValue = await getHouseOption();
    const gameResult = getResult(type, houseOptionValue);
    setResult(gameResult);
    gameResult === "WIN" && updateScore(score + 1);
    gameResult === "LOSE" && updateScore(score - 1);
  };

  const handlePlayAgain = () => {
    setPlay(false);
    setResult(null);
  };

  return (
    <>
      <Transition in={result ? false : true} type="fade" nodeRef={optionsRef}>
        <GridOptions play={play} result={result}>
          {options.map((option) => (
            <Option
              key={option}
              type={option}
              handleTookOption={handleTookOption}
              play={play}
            />
          ))}
        </GridOptions>
      </Transition>
      <Transition in={play} type="translateYFromTop" nodeRef={gameRef}>
        <PlayGroundStyled play={play} result={result} ref={gameRef}>
          <div className="option-container">
            <Option type={option} play={play} showShadow={result === "WIN"} />
            <p>YOU PICKED</p>
          </div>
          <div className="option-container">
            <Option
              type={houseOption}
              play={play}
              showShadow={result === "LOSE"}
            />
            <p>THE HOUSE PICKED</p>
          </div>
          <Transition
            in={result ? true : false}
            type="translateYFromBottom"
            nodeRef={resultRef}
          >
            <div className="result-container" ref={resultRef}>
              <h3>YOU {result}</h3>
              <Button onClick={handlePlayAgain} variant="primary" width="100%">
                PLAY AGAIN
              </Button>
            </div>
          </Transition>
        </PlayGroundStyled>
      </Transition>
    </>
  );
};

export default PlayGround;

const GridOptions = styled.div`
  background: url("./images/bg-triangle.svg") no-repeat center;
  background-size: 250px 70%;
  display: ${({ play }) => (play ? "none" : "grid")};
  grid-template-columns: repeat(2, 125px);
  justify-content: center;
  justify-items: center;
  gap: 25px 70px;
  div:nth-child(3) {
    grid-column: span 2;
  }
  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(2, 250px);
    background-size: 50%;
    gap: 40px 70px;
  }
`;

const PlayGroundStyled = styled(GridOptions)`
  background: none;
  display: ${({ play }) => (play ? "grid" : "none")};
  gap: 60px 70px;

  .option-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    color: white;
    text-align: center;
    font-weight: 700;
  }
  .result-container {
    h3 {
      color: white;
      font-size: 4rem;
      margin-bottom: 1rem;
    }
  }

  @media screen and (min-width: 1024px) {
    grid-template-columns: ${({ play, result }) =>
      play && result ? "250px 300px 250px" : "repeat(2, 250px)"};
    background-position: center;
    background-size: 60%;
    gap: 40px 70px;
    div:nth-child(3) {
      align-self: center;
      text-align: center;
      grid-column: 2 / 3;
      grid-row: 1;
    }
    .option-container {
      flex-direction: column-reverse;
      font-size: 1.5rem;
      gap: 4rem;
    }
  }
`;
